export const SET_LANGUAGE = "SET_LANGUAGE";
export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const HIDE_TRANSITION = "HIDE_TRANSITION";
export const HIDE_CHAPTERS = "HIDE_CHAPTERS";
export const SHOW_CHAPTERS = "SHOW_CHAPTERS";

export const HIDE_GAME = "HIDE_GAME";
export const SHOW_GAME = "SHOW_GAME";
export const SHOW_TRANSITION = "SHOW_TRANSITION";
// export const SET_CONNECTIVITY = "SET_CONNECTIVITY";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js